export default "__VITE_ASSET__4vGE7fOT__"